import { jsx } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { Item } from "./Item2.js";
import { Text } from "./Text.js";
import { Dropdown } from "./Dropdown.js";
import { Input } from "./Input.js";
import { ListItem } from "./ListItem.js";
function Combobox({
  children,
  openOn = "type",
  isAnyValueAllowed = false,
  value,
  onChange,
  onOpen,
  onClose,
  onClean,
  icon,
  placeholder,
  id,
  iconRight,
  isDisabled,
  ...props
}) {
  const [savedValue, setSavedValue] = useState("");
  const containerRef = useRef(null);
  return /* @__PURE__ */ jsx(Dropdown.OffsetContext.Provider, {
    value: "extra",
    children: /* @__PURE__ */ jsx(Dropdown, {
      containerRef,
      trigger: ({
        isOpen,
        onClick,
        onKeyDown,
        ...triggerProps
      }, {
        open,
        close
      }) => /* @__PURE__ */ jsx(Input, {
        onFocus: () => {
          if (openOn === "focus") {
            open();
          }
          if (!isAnyValueAllowed) {
            setSavedValue(value);
          }
        },
        onBlur: (event) => {
          var _a;
          if (isAnyValueAllowed) {
            return;
          }
          const isClickInsideContainer = (_a = containerRef.current) == null ? void 0 : _a.contains(event.relatedTarget);
          if (!isClickInsideContainer) {
            if (value.trim().length > 0) {
              close();
              onChange(savedValue);
            }
          }
        },
        onClean,
        value,
        onChange: (newValue) => {
          onChange(newValue);
          if (newValue.trim().length > 0) {
            open();
          }
          if (openOn === "type" && newValue.trim().length === 0) {
            close();
          }
        },
        iconRight: iconRight || (openOn === "focus" ? /* @__PURE__ */ jsx(Dropdown.Arrow, {}) : void 0),
        icon,
        placeholder,
        id,
        hasClearButton: true,
        role: "combobox",
        "aria-autocomplete": "list",
        isDisabled,
        ...triggerProps
      }),
      position: "bottom",
      isKeepingFocusOnTrigger: isAnyValueAllowed,
      role: "listbox",
      onOpen,
      onClose,
      ...props,
      children: openOn === "type" && value.trim().length === 0 ? null : children
    })
  });
}
Combobox.Item = Item;
Combobox.ListItem = ListItem;
Combobox.Text = Text;
export {
  Combobox
};
//# sourceMappingURL=Combobox.js.map
